// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/it'
import App from './App'
import router from './router'
// import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
// import socketio from 'socket.io'
// import VueSocketIO from 'vue-socket.io'
// export const SocketInstance = socketio('http://localhost:44544')
// Vue.use(VueSocketIO, SocketInstance)
// import VueSocketIO from 'vue-socket.io'
import VueAnalytics from 'vue-analytics'
import VueI18n from 'vue-i18n'
import messages from './locale'
import VueDragDrop from 'vue-drag-drop'
import VueDragResize from 'vue-drag-resize'
var sockethost = process.env.ROOT_SOCKET
import VueSocketio from 'vue-socket.io-extended'
import io from 'socket.io-client'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueMq from 'vue-mq'

Vue.component(VueQrcode.name, VueQrcode)
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})
Vue.use(VueAnalytics, {
  id: 'UA-124191030-1',
  router,
  beforeFirstHit () {
    Vue.$ga.set('anonymizeIp', true)
  }
})
// import VueGridLayout from 'vue-grid-layout'
// import VueDragscroll from 'vue-dragscroll'

// Vue.use(VueDragscroll)
// Vue.use(VueGridLayout)
Vue.use(VueSocketio, io(sockethost))
Vue.component('vue-drag-resize', VueDragResize)
Vue.use(router)
Vue.use(VueDragDrop)
Vue.use(VueI18n)
// Vue.use(ElementUI)
Vue.use(ElementUI, { locale })
// Vue.use(VueSocketio, 'http://127.0.0.1:44544')
// Vue.use(VueSocketio, sockethost)
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: sockethost
// }))

Vue.config.productionTip = false

// Vue.use(Notifications)
Vue.use(VModal, { dynamic: true })

// const messages = {
//   en: {
//     message: {
//       welcome: 'Welcome',
//       settings: 'Settings'
//     }
//   },
//   it: {
//     message: {
//       welcome: 'Benvenuto',
//       settings: 'Impostazioni'
//     }
//   },
//   de: {
//     message: {
//       welcome: 'Willkommen',
//       settings: 'Einstellungen'
//     }
//   }
// }

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js